import { AuthContext } from '@repo-level/core-front';
import { createScript, deleteScript } from 'helpers/common';
import type { FC } from 'react';
import { createContext, useContext, useEffect } from 'react';
import { NotificationProvider, notificationsMap } from './3rdParty';

export const NotificationsContext = createContext<{}>(null as any);

export const NotificationsContextProvider: FC = ({ children }) => {
  const { user } = useContext(AuthContext);

  const { path, identifyUser, resetUser } =
    window.appConfig.APP_ENV === 'development'
      ? notificationsMap[NotificationProvider.None]
      : notificationsMap[NotificationProvider.CustomerIO];

  useEffect(() => {
    if (user?.id == null) return;

    identifyUser(user.id);

    return () => {
      resetUser();
    };
  }, [user, identifyUser, resetUser]);

  useEffect(() => {
    if (path == null) return;

    createScript(path);

    return () => {
      deleteScript(path);
    };
  }, [path]);

  return (
    <NotificationsContext.Provider value={{}}>
      {children}
    </NotificationsContext.Provider>
  );
};
